<aga-navigation-bar *ngIf="clinicsAreLoaded && isUserLoggedIn() && !navBarOptions?.hideNavigationBar"
                    [navigationBarOptions]="navBarOptions" (logOut)="logOut()"></aga-navigation-bar>
<section class="container">
	<router-outlet></router-outlet>
</section>
